<template>
  <div class="mf-card incremental-revenue-container" data-userflow-id="incremental-revenue-container">
    <div class="incremental-revenue-header">
      <h2 class="header-title">Faturamento incremental clube</h2>
      <span class="header-subtitle">Faturamento incremental a partir de ofertas do clube</span>
    </div>

    <div class="incremental-revenue-body">
      <div class="body-chart">
        <incremental-revenue-chart
          ref="incrementalRevenueChart"
          :analysed-period="analysedPeriod"
          :analysed-period-weekly="analysedPeriodWeekly"
          :is-isolated="isIsolated"
          :all-month-metrics="getAllMonthMetrics"
          @change-page="changeFormattedLabel"
        />
      </div>

      <incremental-revenue-chart-metrics :formatted-date-label="chartMetricsLabel" />
    </div>

    <div class="incremental-revenue-expansion">
      <mf-button
        text
        :label="`Ver ${expand ? 'menos' : 'mais'} detalhes`"
        :icon="`expand_${expand ? 'less' : 'more'}`"
        text-transform="none"
        color="marca-0-l40"
        @click="expand = !expand"
      />
    </div>

    <Transition>
      <div v-if="expand" class="incremental-revenue-details">
        <div v-if="!isEmpty" class="line"></div>
        <incremental-revenue-details :formatted-date-label="formattedDateLabel" :dre-period-id="drePeriodId" />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import IncrementalRevenueChart from './IncrementalRevenueChart.vue'
import IncrementalRevenueDetails from './IncrementalRevenueDetails.vue'
import IncrementalRevenueChartMetrics from './IncrementalRevenueChartMetrics.vue'
import { DateTime } from 'luxon'
export default {
  name: 'IncrementalRevenue',
  components: {
    IncrementalRevenueChart,
    IncrementalRevenueDetails,
    IncrementalRevenueChartMetrics,
  },
  props: {
    formattedDateLabel: {
      type: String,
      default: '',
    },
    drePeriodId: {
      type: String,
      default: '',
    },
    analysedPeriod: {
      type: String,
      default: '',
    },
    analysedPeriodWeekly: {
      type: Array,
      default: () => ['', ''],
    },
  },
  data: () => ({
    expand: false,
    chartMetricsLabel: '',
  }),
  computed: {
    ...mapGetters(['dreRevenueIncrementMetrics', 'analyticsConfiguration', 'dreRevenueIncrementMetrics']),
    isEmpty() {
      return this.dreRevenueIncrementMetrics?.detailsMetrics === undefined
    },
    isIsolated() {
      return this.analyticsConfiguration?.model === 'NOT_RECURRENT'
    },
    getAllMonthMetrics() {
      const metrics = this.dreRevenueIncrementMetrics?.periodMetrics?.dailyMetrics
      return metrics
        ? Object.values(
            metrics.reduce((acc, item) => {
              const month = item.date.slice(0, 7)
              if (!acc[month]) {
                acc[month] = []
              }
              acc[month].push(item)
              return acc
            }, {})
          )
        : []
    },
  },
  watch: {
    drePeriodId() {
      this.changeFormattedLabel()
    },
    formattedDateLabel() {
      this.changeFormattedLabel()
    },
  },
  mounted() {
    this.changeFormattedLabel()
  },
  methods: {
    changeFormattedLabel(page) {
      if (!this.isIsolated) {
        this.chartMetricsLabel = this.formattedDateLabel
        return
      }
      const metric = this.getAllMonthMetrics?.[page]?.[0]
      if (metric) {
        const formattedDate = DateTime.fromISO(metric.date).setLocale('pt-BR').toFormat("LLLL 'de' yyyy")
        this.chartMetricsLabel = formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.incremental-revenue-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  .incremental-revenue-header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    .header-title {
      color: $cinza-d10;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
    .header-subtitle {
      color: $cinza-0;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
  .incremental-revenue-expansion {
    ::v-deep .v-btn__content {
      font-size: 14px !important;
      font-weight: 400;
      line-height: 18px;
      letter-spacing: 0.01em;

      .mf-icon {
        font-size: 18px !important;
      }
    }
  }
  .incremental-revenue-body {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: left;
    gap: 48px;
    .body-chart {
      width: 80% !important;
    }
    .body-data {
      min-width: 260px;
    }
  }
  .incremental-revenue-details {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .line {
      width: 100%;
      border-top: 1px solid #b4bac0;
    }
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translatey(-10px);
  opacity: 0;
}
</style>
